import { Divider } from '@mui/material';
import React from 'react';
import { PodcastPlaysView } from '../types';
import { OPTIONS } from './constants';
import * as S from './styles';
import ToggleOption from './ToggleOption';
import { viewToIndex } from './utils';

type PlaysDashboardToggleProps = {
  view: PodcastPlaysView;
  onChange: () => void;
  className?: string;
};

const PlaysDashboardToggle: React.FC<PlaysDashboardToggleProps> = ({
  view,
  onChange,
  className,
}) => (
  <div className={className}>
    <Divider flexItem>
      <S.Group onPress={onChange}>
        <S.Options $selectedIndex={viewToIndex(view)}>
          {OPTIONS.map((opt) => (
            <ToggleOption selected={view === opt.value} key={opt.value}>
              {opt.label}
            </ToggleOption>
          ))}
        </S.Options>
      </S.Group>
    </Divider>
  </div>
);
export default PlaysDashboardToggle;
